import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, ArrowRight } from "lucide-react";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <div className="flex min-h-[80vh] items-center justify-center px-5 pt-24">
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <div className="text-center">
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="font-serif text-[8rem] md:text-[12rem] leading-none text-gold/30">404</motion.p>
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }}
          className="-mt-6 font-serif text-4xl md:text-5xl font-light tracking-tighter">This path isn't in your numbers.</motion.h1>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.25 }}
          className="mt-5 text-lg font-light text-muted-foreground">The page you're looking for may have moved or never existed.</motion.p>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }}
          className="mt-8 flex flex-wrap justify-center gap-4">
          <Link to="/" className="inline-flex items-center gap-2 rounded-full bg-primary px-7 py-3.5 text-primary-foreground transition-all hover:-translate-y-0.5 hover:shadow-gold"><Home className="h-4 w-4" /> Back home</Link>
          <Link to="/tools" className="inline-flex items-center gap-2 rounded-full border border-border bg-white px-7 py-3.5 transition-colors hover:border-primary">Explore tools <ArrowRight className="h-4 w-4" /></Link>
        </motion.div>
      </div>
    </div>
  );
}
